import { useState, type ReactNode } from "react";
import { Confirmacao, type PedidoDeConfirmacao } from "./Confirmacao";

/*
 * Desligar pede motivo, ligar pede confirmação leve.
 *
 * Cedente, conta e convênio repetem o mesmo gesto, com rotas diferentes (spec "O
 * interruptor de situação pede motivo"), e o gesto sai de dois lugares: o `Interruptor`
 * da linha e o item do `MenuDeLinha`. Os dois chamam `pedir`, e `dialogo` vai uma vez só
 * no JSX de quem usa.
 *
 * Quem chama cuida da rota e do aviso em `aoAlterar`. Lançar mantém o diálogo aberto,
 * com a recusa dentro dele e o motivo digitado.
 */
interface TextoDaConfirmacao {
  titulo: string;
  /** A consequência, numa frase. */
  corpo: ReactNode;
  /** O verbo do resultado: "Bloquear cedente". */
  verbo: string;
}

export function useAlternarSituacao({
  ligado,
  desligar,
  ligar,
  aoAlterar,
}: {
  ligado: boolean;
  desligar: TextoDaConfirmacao;
  ligar: TextoDaConfirmacao;
  /** `motivo` é vazio ao ligar. */
  aoAlterar: (ligar: boolean, motivo: string) => Promise<void>;
}) {
  const [pedido, setPedido] = useState<PedidoDeConfirmacao | null>(null);

  function pedir() {
    setPedido(
      ligado
        ? { severidade: "destrutiva", ...desligar, exigeJustificativa: true }
        : { severidade: "leve", ...ligar },
    );
  }

  return {
    pedir,
    dialogo: (
      <Confirmacao
        pedido={pedido}
        aoCancelar={() => setPedido(null)}
        aoConfirmar={async (motivo) => {
          await aoAlterar(!ligado, motivo);
          setPedido(null);
        }}
      />
    ),
  };
}
